import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import { userDashboardSkeletonCSS } from './Skeletons.css';

const UserDashboardSkeleton = () => (
    <div css={userDashboardSkeletonCSS()} aria-busy="true" aria-live="polite">
        <div className="uds-container">
            {/* Header */}
            <div className="uds-header">
                <div className="uds-header-left">
                    <Skeleton width="60%" height="1.6rem" borderRadius="6px" />
                    <Skeleton width="80%" height="0.9rem" borderRadius="6px" />
                </div>
                <div className="uds-header-right">
                    <Skeleton width="100px" height="0.7rem" borderRadius="4px" />
                    <Skeleton width="160px" height="1.1rem" borderRadius="6px" />
                </div>
            </div>

            {/* Body: sidebar + main */}
            <div className="uds-body">
                <div className="uds-sidebar">
                    <Skeleton shape="circle" size="8rem" />
                    <Skeleton width="60%" height="1.1rem" borderRadius="6px" />
                    <Skeleton width="75%" height="0.8rem" borderRadius="6px" />

                    <div className="uds-sidebar-stats">
                        {Array.from({ length: 3 }).map((_, i) => (
                            <div key={i} className="uds-stat-row">
                                <Skeleton shape="circle" size="1.3rem" />
                                <div className="uds-stat-text">
                                    <Skeleton width="40%" height="0.65rem" borderRadius="4px" />
                                    <Skeleton width="70%" height="0.85rem" borderRadius="6px" />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="uds-main">
                    {/* Progress card */}
                    <div className="uds-card">
                        <Skeleton width="40%" height="1.1rem" borderRadius="6px" />
                        <div style={{ height: '0.6rem' }} />
                        <Skeleton width="100%" height="0.6rem" borderRadius="6px" />
                        <div className="uds-stepper-row">
                            {Array.from({ length: 4 }).map((_, i) => (
                                <Skeleton key={i} width="90px" height="2.2rem" borderRadius="10px" />
                            ))}
                        </div>
                    </div>

                    {/* Step content card */}
                    <div className="uds-card" style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.75rem', padding: '2rem' }}>
                        <Skeleton shape="circle" size="4rem" />
                        <Skeleton width="50%" height="1.4rem" borderRadius="6px" />
                        <Skeleton width="70%" height="0.9rem" borderRadius="6px" />
                        <Skeleton width="60%" height="0.9rem" borderRadius="6px" />
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default UserDashboardSkeleton;
